import React from 'react'
import img1 from "../../assets/cam1.jpeg";
import img3 from "../../assets/3-camera_lockup_white.png";
import img4 from "../../assets/cm104-1.jpg";
import img2 from "../../assets/essential-xl-v2-right.png";
import { Link } from 'react-router-dom';


const Arrivals = () => {
  return (
    <section className="section-wrap new-arrivals pb-40">
    <div className="container">

      <div className="row heading-row">
        <div className="col-md-12 text-center">
          <h2 className="heading uppercase"><small>New Arrivals</small></h2>
        </div>
      </div>

      <div className="row row-10">              

        <div className="col-md-3 col-xs-6">
          <div className="product-item">
            <div className="product-img">
            <Link to={"/Singleproduct"}>
                <img src={img1} alt=""/>
           
              </Link>
              <div className="product-label">
                <span className="sale">sale</span>
              </div>
              <div className="product-actions">
                <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                  <i className="fa fa-exchange"></i>
                </a>
                <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                  <i className="fa fa-heart"></i>
                </a>                    
              </div>
              <a href="#" className="product-quickview">Quick View</a>
            </div>
            <div className="product-details">
              <h3>
                <a className="product-title" href="#">Night Party Dress</a>
              </h3>
              <span className="price">
                <del>
                  <span>$388.00</span>
                </del>
                <ins>
                  <span className="ammount">$159.99</span>
                </ins>
              </span>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-xs-6">
          <div className="product-item">
            <div className="product-img">
            <Link to={"/Singleproduct"}>
                <img src={img2} alt=""/>
               
              </Link>
              <div className="product-actions">
                <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                  <i className="fa fa-exchange"></i>
                </a>
                <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                  <i className="fa fa-heart"></i>
                </a>                    
              </div>
              <a href="#" className="product-quickview">Quick View</a>
            </div>
            <div className="product-details">
              <h3>
                <a className="product-title" href="#">Elegant White Dress</a>
              </h3>
              <span className="price">
                <ins>
                  <span className="ammount">$219.00</span>
                </ins>
              </span>
            </div>                          
          </div>
        </div>

        <div className="col-md-3 col-xs-6">
          <div className="product-item">
            <div className="product-img">
            <Link to={"/Singleproduct"}>
                <img src={img3} alt=""/>
               
              </Link>
              <span className="sold-out valign">out of stock</span>
              <div className="product-actions">
                <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                  <i className="fa fa-exchange"></i>
                </a>
                <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                  <i className="fa fa-heart"></i>
                </a>                    
              </div>
              <a href="#" className="product-quickview">Quick View</a>
            </div>
            <div className="product-details">
              <h3>
                <a className="product-title" href="#">Long Black Dress</a>
              </h3>
              <span className="price">
                <ins>
                  <span className="ammount">$99.00</span>
                </ins>
              </span>
            </div>                        
          </div>
        </div>

        <div className="col-md-3 col-xs-6">
          <div className="product-item">
            <div className="product-img">
              <Link to={"/Singleproduct"}>
                <img src={img4} alt=""/>
              </Link>
              <div className="product-actions">
                <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                  <i className="fa fa-exchange"></i>
                </a>
                <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                  <i className="fa fa-heart"></i>
                </a>                    
              </div>
              <a href="#" className="product-quickview">Quick View</a>
            </div>
            <div className="product-details">
              <h3>
                <a className="product-title" href="#">Sexy Pink Dress</a>
              </h3>
              <span className="price">
                <ins>
                  <span className="ammount">$120.00</span>
                </ins>
              </span>
            </div>                        
          </div>
        </div>            

      </div> 
      <Link to={"/shop"} className='mx-auto text-center d-block'>
      <button className="button"> View More !
      </button>

      </Link>
    </div>
  </section>
  )
}

export default Arrivals